import { Box, SxProps } from "@mui/material";

const withVerticalCenter = (
  component: JSX.Element,
  sx: SxProps = {}
): JSX.Element => (
  <Box
    sx={{
      justifyContent: "center",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      ...sx,
    }}
  >
    {component}
  </Box>
);

export default withVerticalCenter;
